const COEFF = 1000 * 60 * 5;
export default function roundTime(datetime) {
    return new Date(Math.round(datetime?.getTime() / COEFF) * COEFF);
}
